/* eslint-disable react/no-unescaped-entities */
import { Meta } from '@/layout/Meta';
import { Legal } from '@/templates/Legal';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { note } from '@/utils/Note';
import { DessertIcon } from '@/utils/DessertIcon';

const AboutUs = () => {
  const router = useRouter()

  useEffect(() => {
    note('About Us')
  }, [])
  
  return (
    <Legal meta={<Meta 
        title="About Us"
        description="About Us" />}>
        <h1 className="font-bold text-4xl">About Us</h1>
        <main>
          <p>
            Dessert Data, LLC is a US 🇺🇸 based digital advertising consultancy.  We provide a fully managed data platform 
            for clients world wide.
          </p>
          <section className="block md:flex items-center">
            <div>
              <h2 className="font-bold text-2xl">Our Mission</h2>
              <p>
                Help clients access their digital advertising 
                data with hands-on service at a reasonable cost.
              </p>
            </div>
            <img 
              src={`${router.basePath}/assets/images/heros/digital-icecream.jpeg`} 
              className="rounded-3xl h-64 mx-auto my-10 md:m-5"
            />
          </section>
          <section className="block md:flex items-center">
            <img 
              src={`${router.basePath}/assets/images/heros/making-cake.jpeg`} 
              className="hidden md:block rounded-3xl h-64 m-5"
            />
            <div>
              <h2 className="font-bold text-2xl">Why We're Different</h2>
              <p>
                Our service means you don't need to maintain any infrastructure, operate
                integrations, monitor system health, or host a database.  
              </p>
              <p className='italic'>
                We can even get you setup. <DessertIcon rand={Math.random()} icon='cake'/>
              </p>
              <img 
                src={`${router.basePath}/assets/images/heros/making-cake.jpeg`} 
                className="block md:hidden rounded-3xl h-64 m-auto"
              />
            </div>
          </section>
        </main>
    </Legal>
  );
};

export default AboutUs
